import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { DxTextBoxTypes } from 'devextreme-angular/ui/text-box';
import { firstValueFrom } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { MasterApiService } from 'src/app/services/master-api.service';
import { environment } from 'src/environments/environment';
import {Router} from "@angular/router";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.sass'],
    standalone: false
})
export class LoginComponent {

  loginLogo = environment.loginLogo + '?rnd=' + new Date().getTime();

  passwordError: string = "#f7505e";
  showForgotPasswordForm: boolean = false;
  passwordMode: DxTextBoxTypes.TextBoxType = 'password';

  passwordButton: DxButtonTypes.Properties = {
    icon: 'eyeopen',
    stylingMode: 'text',
    onClick: () => {
      this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
    },
  };

  userName: string;
  password: string;
  email: string;

  forgotPasswordText: string;

  emailSended: boolean = false;
  emailSendedText: string = '';
  backToLoginText: string;

  backgroundLoginButtonColor: string = '#5e5e5e';

  capsLock:boolean = false;
  capsLockMessage:string;

  constructor(private authService: AuthService, private alertService: AlertService, private translateService: TranslateService, private router: Router, private api: MasterApiService) {
    this.passwordError = '';
    this.userName = '';
    this.password = '';
    this.email = '';
    this.forgotPasswordText = this.translateService.instant('common.forgotPassword');
    this.backToLoginText = this.translateService.instant('common.backToLoginText');

    this.capsLockMessage = this.translateService.instant('common.capsLockIsOn');
    document.addEventListener('keyup', (e) => this.capsLock = e.getModifierState('CapsLock'));

    if (environment.showDefaultCredentialsOnLogin) {
      this.userName = 'admin';
      this.password = 'GlAm123$';
    }
  }

  async login() {
    try {
      const username = this.userName;
      const password = this.password
      await this.authService.login(username, password);
      if(this.api.auth.userValue?.homeList && this.api.auth.userValue?.homeList.length > 0){
        await this.router.navigate(['/common/homes']);

      }
    } catch (error) {
      this.passwordError = this.translateService.instant("common.InvalidPassword");
    }
  }

  async doLogin()
  {
    this.login();
  }

  showForgotPasswordView(){
    this.showForgotPasswordForm = true;
    if (this.userName.includes('@') && this.userName.includes('.')) {
      this.email = this.userName;
    }

    this.userName = '';
    this.password = '';
    this.passwordError = ''
  }

  showLoginView(){
    if (this.email.includes('@') && this.email.includes('.')) {
      this.userName = this.email;
    }

    this.showForgotPasswordForm = false;
    this.email = '';
    this.emailSended = false;
  }

  async forgotPassword() : Promise<void>
  {
    this.emailSendedText = this.translateService.instant('common.resetPasswordEmailSent', { email: this.email });
    try{
      await firstValueFrom(this.api.forgotPassword(this.email));
      this.emailSended = true;
    } catch (error) {
      if (error instanceof HttpErrorResponse && error.status >= 400 && error.status <= 499) {
        this.emailSended = true;
        //this.showLoginView();
      } else if (error instanceof HttpErrorResponse && error.status >= 500 && error.status <= 599)
      {
        this.emailSended = false;
        this.alertService.error(error as Error);
      }
    }
  }

}
